module.exports = __webpack_public_path__ + "static/img/1-12.e8f95e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/1-12.png
// module id = 3dIu
// module chunks = 0